import React from 'react'

const Social = () => {
  return (
    <div className='home__social'>
        <a href="https://github.com/MattGaviria" className="home__social-icon" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-github"></i>
        </a>

        <a href="https://www.linkedin.com/in/cmateogaviria/" className="home__social-icon" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-linkedin"></i>
            
        </a>

        <a href="https://www.instagram.com/mattgaviria/" className="home__social-icon" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-instagram"></i>
            
        </a>
    </div>
  );
};

export default Social;